import {
  Component,
  TemplateRef,
  OnInit,
  inject,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetModule,
} from '@angular/material/bottom-sheet';
import { QuickInvoiceBottomSheetComponent } from '@app/quick-invoice-bottom-sheet/quick-invoice-bottom-sheet.component';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgForm } from '@angular/forms';
import { InvoiceApi } from '@app/services/invoice-api';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { DocumentTypeOptions, InvoiceInterface } from '@app/interface/invoice';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { CompanyApi } from '@app/services/company-api';
import { CompanyInterface } from '@app/interface/company';
import { Observable, Subscription } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
// import {AsyncPipe} from '@angular/common';
import { map, startWith } from 'rxjs/operators';
// import { OnInit } from '@angular/core';
import { CompanyAutocompleteComponent } from '@app/company-autocomplete/company-autocomplete';
// import { LayoutComponent } from '@app/layout/layout.component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSort, Sort, MatSortModule } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import {
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { DatePipe } from '@angular/common';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { CustomPaginatorIntl } from '@app/services/custom-paginator-intl.service';
import {
  NativeDateAdapter,
  DateAdapter,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { ConfirmEmailSendDialogComponent } from '@app/confirm-email-send-dialog/confirm-email-send-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { from, of, forkJoin } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StatusInfoDialogComponent } from '@app/status-info-dialog/status-info-dialog.component';
import { Organizations } from '@app/interface/organizations';
import { OrganizationApi } from '@app/services/organization-api.service';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { ProductServiceInterface } from '@app/interface/product-service';
import { ProductserviceApiService } from '@app/services/productservice-api.service';
import { QuickInvoiceTransferService } from '@app/services/quick-invoice-transfer.service';
import { ToastService } from '@app/services/toast.service';

export type DocumenTypeCode = 'TD01' | 'TD04';

@Component({
  selector: 'app-invoices-table',
  templateUrl: './invoices-table.html',
  styleUrls: ['./invoices-table.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    // AsyncPipe,
    // CompanyAutocompleteComponent,
    // LayoutComponent,
    MatPaginatorModule,
    MatPaginator,
    MatCardModule,
    MatCheckboxModule,
    MatSortModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatChipOption,
    MatChipsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionPanel,
    MatProgressSpinnerModule,
    DatePipe,
    BackHeaderComponent,
    MatTooltipModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    // MatDialogClose,
    MatBottomSheetModule,
  ],
  providers: [InvoiceApi, CompanyApi],
  standalone: true,
})
export class InvoicesTable implements AfterViewInit, OnInit, OnDestroy {
  private toast = inject(ToastService);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatExpansionPanel) expansionPanel!: MatExpansionPanel;
  @ViewChild('amountInfoDialog') amountInfoDialog!: TemplateRef<any>;

  showDelay = new FormControl(500);
  hideDelay = new FormControl(1000);

  private _liveAnnouncer = inject(LiveAnnouncer);

  totalInvoices: number = 0;
  paidInvoices: number = 0;

  totalAmountThisYear: number = 0;
  totalAmountCreditThisYear: number = 0;
  currentYear = new Date().getFullYear();
  organization_data: Organizations | null = null;

  filterPanelOpenState = false;
  advancedFilters = false; // Toggle for advanced filters

  // bulk actions
  // Selection model for tracking selected invoices
  selection = new SelectionModel<any>(true, []); // true = allow multiple selection
  selectedInvoices: any[] = [];

  // year filter
  years: number[] = [];
  selectedYear: number = this.currentYear;

  getActiveFilterCount(): number {
    return Object.values(this.filters).filter(
      (val) => val !== null && val !== '',
    ).length;
  }

  getStatusColor(status: string): string {
    switch (status?.toUpperCase()) {
      case 'ATTESA':
        return 'primary';
      default:
        return '';
    }
  }

  PensionFundMap: Record<string, string> = {
    TC01: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
    TC02: 'Cassa previdenza dottori commercialisti',
    TC03: 'Cassa previdenza e assistenza geometri',
    TC04: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
    TC05: 'Cassa nazionale del notariato',
    TC06: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
    TC07: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
    TC08: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
    TC09: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
    TC10: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
    TC11: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
    TC12: "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)",
    TC13: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
    TC14: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
    TC15: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
    TC16: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
    TC17: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
    TC18: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
    TC19: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
    TC20: 'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
    TC21: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)',
    TC22: 'INPS',
  };

  getFundName(code: string | undefined): string {
    if (!code) return 'Cassa non specificata';

    // Return the mapped name, or the raw code if it's somehow not in the list
    return this.PensionFundMap[code] || code;
  }

  displayedColumns: string[] = [
    'selectAll',
    'Actions',
    'paidToggle', // checkbox
    'document_type',
    // 'invoice_name',
    'amount',
    // 'currency',
    // 'organization_id',
    'company',
    'progressive_number',
    'emission_date',
    'payment_date',
    // 'is_draft',
    'status',
  ];
  dataSource = new MatTableDataSource<InvoiceInterface>([]); // now usng MatTableDataSource
  companySource = new MatTableDataSource<CompanyInterface>([]); // now usng MatTableDataSource

  myControl = new FormControl('');
  companyNames: string[] = []; // Array to store company names
  filteredOptions!: Observable<string[]>;

  // filter for the table
  filters: any = {
    amount_gt: null,
    amount_lt: null,
    emission_date_after: null, // New min emission date
    emission_date_before: null, // New max emission date
    payment_date_after: null, // New min payment date
    payment_date_before: null, // New max payment date
    status: null,
    company_name_icontains: null,
  };

  filterOptions = [
    { name: 'Tutte', value: 'all' },
    { name: 'Pagate', value: 'paid' },
    { name: 'Non pagate', value: 'unpaid' },
  ];

  documentTypeOptions: DocumentTypeOptions[] = [
    { code: 'TD01', name: 'Fattura' },
    { code: 'TD04', name: 'Nota di credito' },
  ];

  selectedFilter = 'all';
  filteredInvoices: InvoiceInterface[] = []; // For mobile cards

  newInvoice: Partial<InvoiceInterface> = {
    invoice_name: '',
    amount: 0,
    organization_id: 1,
    // company: {company_name:'default', id:1},
    company_id: 1,
    currency: 'EUR',
  };

  newCompany: Partial<CompanyInterface> = {
    id: 1,
    company_name: '',
    organization_id: 1,
    company_id: 1,

    iva_number: '',
    ateco_code: '',
  };
  filterValue: string = 'all';

  constructor(
    private invoiceService: InvoiceApi,
    private companyService: CompanyApi,
    public organizationService: OrganizationApi,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet,
    private productServiceApi: ProductserviceApiService,
    private quickInvoiceTransferService: QuickInvoiceTransferService,
  ) {}

  isLoading = true;

  // getAllInvoices restituisce un Subject che non completa mai: senza tenere
  // la sottoscrizione, un caricamento lento (es. anno precedente) puo'
  // arrivare dopo quello nuovo e sovrascrivere la tabella.
  private invoicesSub?: Subscription;

  ngOnInit() {
    this.loadInvoices();
    this.loadCompanies();
    this.getOrganization();

    this.generateYears();

    // Initialize filteredOptions after companies are loaded
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this._filter(value || '')),
    );

    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.invoicesSub?.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.dataSource.sort = this.sort;

      // Set default sorting by progressive_number descending (most recent first)
      this.sort.sort({
        id: 'progressive_number',
        start: 'desc',
        disableClear: false,
      });
    }

    this.paginator._intl.itemsPerPageLabel = 'Elementi per pagina:';
    this.paginator._intl.nextPageLabel = 'Pagina successiva';
    this.paginator._intl.previousPageLabel = 'Pagina precedente';
    this.paginator._intl.firstPageLabel = 'Prima pagina';
    this.paginator._intl.lastPageLabel = 'Ultima pagina';

    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };
  }

  private getOrganization() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const filterParams = {
      organization_id: organization_id,
    };

    this.organizationService
      .getOrganization<Organizations>(organization_id, filterParams)
      .subscribe({
        next: (organization_data: Organizations) => {
          // console.log('Organization:', organization_data);
          this.organization_data = organization_data; // Store the organization data

          // Apply theme based on organization source
          // this.applyOrganizationTheme(this.organization_data.source);

          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading organization:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.cdr.detectChanges();
        },
        // Remove complete() if you're handling everything in next/error
      });
  }

  generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2024; // You can change this start year
    const endYear = currentYear + 2; // You can change this end year

    for (let year = startYear; year <= endYear; year++) {
      this.years.push(year);
    }

    // Optionally set default selection
    this.selectedYear = currentYear;
  }

  onYearSelected(event: MatSelectChange): void {
    this.loadInvoices();
  }

  formatDateForDisplay(date: Date): string {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getDate() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatDateForBackend(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  // Update your date properties with getters/setters
  private _emissionDateAfter: Date | null = null;

  get emissionDateAfter(): Date | null {
    return this._emissionDateAfter;
  }

  set emissionDateAfter(value: Date | null) {
    this._emissionDateAfter = value;
    this.filters.emission_date_after = value
      ? this.formatDateForBackend(value)
      : null;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  // bulk actions
  // Selection helper methods
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows && numRows > 0;
  }

  isSomeSelected(): boolean {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  toggleSelectAll(event: any): void {
    if (event.checked) {
      // Select all filtered rows
      this.dataSource.filteredData.forEach((row) => this.selection.select(row));
    } else {
      // Deselect all
      this.selection.clear();
    }
    this.updateSelectedInvoices();
  }

  toggleSelection(row: any): void {
    this.selection.toggle(row);
    this.updateSelectedInvoices();

    console.log('selectedInvoices', this.selectedInvoices);
  }

  isSelected(row: any): boolean {
    return this.selection.isSelected(row);
  }

  private updateSelectedInvoices(): void {
    this.selectedInvoices = this.selection.selected;
  }

  clearSelection(): void {
    this.selection.clear();
    this.updateSelectedInvoices();
  }

  // Bulk action methods
  bulkDownloadPdf(): void {
    if (this.selectedInvoices.length === 0) {
      this.toast.warning('Seleziona almeno una fattura');
      return;
    }

    // Extract the IDs
    const invoiceIds = this.selectedInvoices.map((invoice) => invoice.id);

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.toast.info('Generazione del file ZIP in corso...', { duration: 2000 });

    // 2. Call the new service method
    this.invoiceService
      .downloadOrganizationInvoicesZipByIds(organization_id, invoiceIds)
      .subscribe({
        next: (blob: Blob) => {
          // 3. Handle the ZIP file download
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `Fatture_scaricate_${organization_id}.zip`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);

          // 4. Clean up UI state
          this.isLoading = false;
          this.showSuccessMessage(`Download completato in un unico file ZIP`);
          this.clearSelection();
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error downloading ZIP:', error);
          this.isLoading = false;
          this.toast.error('Errore durante il download dello ZIP');
          this.cdr.detectChanges();
        },
      });
  }

  // Helper method that wraps the download in a Promise
  private async executeDownload(invoiceId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.downloadPdf(invoiceId);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  // Bulk action XML download
  bulkDownloadXml(): void {
    // Ensure invoices are selected
    if (this.selectedInvoices.length === 0) {
      this.showErrorMessage('Seleziona almeno una fattura.');
      return;
    }

    // 2. Data Preparation
    const invoiceIds = this.selectedInvoices.map((invoice) => invoice.id);
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // 3. UI State: Start Loading
    this.isLoading = true;
    this.toast.info('Generazione del file ZIP XML in corso...', {
      duration: 2000,
    });

    // 4. Service Call: Request the XML ZIP
    // Assumes you added downloadOrganizationInvoicesXmlZipByIds to your service
    this.invoiceService
      .downloadOrganizationInvoicesXmlZipByIds(organization_id, invoiceIds)
      .subscribe({
        next: (blob: Blob) => {
          // 5. Handle the ZIP file download (Browser side)
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;

          // Dynamic filename for XMLs
          link.download = `Fatture_XML_scaricate_${organization_id}.zip`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Cleanup the URL object to free memory
          setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);

          // 6. Finalize UI State
          this.isLoading = false;
          this.showSuccessMessage(
            `Download XML completato in un unico file ZIP`,
          );
          this.clearSelection();
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error downloading XML ZIP:', error);
          this.isLoading = false;
          this.showErrorMessage('Errore durante il download dei file XML.');
          this.cdr.detectChanges();
        },
      });
  }

  // Bulk action: mark selected invoices as paid
  bulkMarkAsPaid(): void {
    if (this.selectedInvoices.length === 0) {
      this.toast.warning('Seleziona almeno una fattura');
      return;
    }

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // Filter only invoices not yet paid to avoid unnecessary calls
    const unpaidInvoices = this.selectedInvoices.filter((inv) => !inv.is_paid);

    if (unpaidInvoices.length === 0) {
      this.toast.info('Tutte le fatture selezionate sono già pagate');
      return;
    }

    this.isLoading = true;

    const updateCalls = unpaidInvoices.map((invoice) =>
      this.invoiceService.updateInvoiceDetails(organization_id, invoice.id, {
        is_paid: true,
      }),
    );

    forkJoin(updateCalls).subscribe({
      next: (updatedInvoices: any[]) => {
        // Update local data source
        updatedInvoices.forEach((updated) => {
          const index = this.dataSource.data.findIndex(
            (i) => i.id === updated.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updated;
          }
        });
        this.dataSource.data = [...this.dataSource.data];

        // Refresh statistics
        this.paidInvoices = this.dataSource.data.filter(
          (i) => i.is_paid,
        ).length;

        this.isLoading = false;
        this.clearSelection();
        this.showSuccessMessage(
          `${updatedInvoices.length} fatture segnate come pagate con successo!`,
        );
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error marking invoices as paid:', error);
        this.isLoading = false;
        this.showErrorMessage("Errore durante l'aggiornamento delle fatture.");
        this.cdr.detectChanges();
      },
    });
  }

  // Bulk action methods
  invoicingSummaryDownloadPdf(): void {
    // if (this.dataSource.filteredData.length === 0) {
    //   this.showErrorMessage('Seleziona almeno una fattura.');
    //   return;
    // }

    // Extract the IDs
    const invoiceIds = this.selectedInvoices.map((invoice) => invoice.id);

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.toast.info('Generazione del report PDF in corso...', { duration: 2000 });

    // 2. Call the new service method
    this.invoiceService
      .downloadInvoicingSummaryPdf(
        organization_id,
        invoiceIds,
        this.selectedYear,
      )
      .subscribe({
        next: (blob: Blob) => {
          const blobUrl = window.URL.createObjectURL(blob);

          // 2. Create a hidden link and click it
          const link = document.createElement('a');
          link.href = blobUrl;

          // You can set a default name or attempt to parse headers if you use
          // observe: 'response' in the HttpClient call above
          link.download = `Situazione_Contabile_${this.organization_data?.name}_${this.selectedYear}.pdf`;

          document.body.appendChild(link);
          link.click();

          // 3. Cleanup
          document.body.removeChild(link);
          setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);

          // 4. Clean up UI state
          this.isLoading = false;
          this.showSuccessMessage(`Download del report completato.`);
          this.clearSelection();
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error downloading ZIP:', error);
          this.isLoading = false;
          this.toast.error('Errore durante il download del report.');
          this.cdr.detectChanges();
        },
      });
  }

  // Helper method that wraps the download XML in a Promise
  private async executeXMLDownload(invoiceId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.downloadXml(invoiceId);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  getDocumentTypeName(code: string): string {
    const found = this.documentTypeOptions.find(
      (option) => option.code === code,
    );
    return found ? found.name : 'Documento';
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
  }

  // Riepilogo mostrato in tooltip al passaggio del mouse sulla riga.
  // Il numero di righe prodotto/servizio non arriva con la lista fatture
  // (che contiene solo l'intestazione), quindi viene caricato al primo hover
  // e messo in cache per fattura.
  private productServiceCounts = new Map<number, number>();
  private loadingProductServiceCounts = new Set<number>();

  onRowHover(invoice: InvoiceInterface): void {
    if (
      !invoice?.id ||
      this.productServiceCounts.has(invoice.id) ||
      this.loadingProductServiceCounts.has(invoice.id)
    ) {
      return;
    }

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.loadingProductServiceCounts.add(invoice.id);

    this.productServiceApi
      .getAllProductsServices<ProductServiceInterface>(
        invoice.id,
        organization_id,
      )
      .subscribe({
        next: (response: RecursiveInterface<ProductServiceInterface>) => {
          if (!response.completed) {
            return;
          }
          this.productServiceCounts.set(invoice.id, response.results.length);
          this.loadingProductServiceCounts.delete(invoice.id);
          this.cdr.markForCheck();
        },
        error: (err: any) => {
          console.error('Error loading product services count:', err);
          this.loadingProductServiceCounts.delete(invoice.id);
        },
      });
  }

  getRowTooltip(invoice: InvoiceInterface): string {
    const documentLine = [
      this.getDocumentTypeName(invoice.document_type),
      invoice.progressive_number ? `N. ${invoice.progressive_number}` : null,
      invoice.enumeration ? `(${invoice.enumeration})` : null,
    ]
      .filter(Boolean)
      .join(' ');

    const count = this.productServiceCounts.get(invoice.id);

    return [
      documentLine,
      `Descrizione: ${invoice.description?.trim() || '—'}`,
      `Prodotti/servizi: ${count === undefined ? 'caricamento…' : count}`,
      `Totale: ${this.formatTableAmount(invoice.amount, invoice.currency)}`,
      `Note: ${invoice.notes?.trim() || '—'}`,
    ].join('\n');
  }

  public loadInvoices() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.cdr.detectChanges();

    // Prepare filter params
    const filterParams: any = {};

    // Add amount filters
    if (this.filters.amount_gt)
      filterParams.amount__gt = this.filters.amount_gt;
    if (this.filters.amount_lt)
      filterParams.amount__lt = this.filters.amount_lt;

    // date filters
    if (this.filters.emission_date_after)
      filterParams.emission_date__gte = this.formatDate(
        this.filters.emission_date_after,
      );
    if (this.filters.emission_date_before)
      filterParams.emission_date__lte = this.formatDate(
        this.filters.emission_date_before,
      );

    if (this.filters.payment_date_after)
      filterParams.payment_date__gte = this.formatDate(
        this.filters.payment_date_after,
      );
    if (this.filters.payment_date_before)
      filterParams.payment_date__lte = this.formatDate(
        this.filters.payment_date_before,
      );

    // Add status filter
    if (this.filters.status) filterParams.status = this.filters.status;

    // Add company name filter
    if (this.filters.company_name_icontains)
      filterParams.company__company_name__icontains =
        this.filters.company_name_icontains;

    // Order by emission date descending (most recent first)
    // filterParams.ordering = '-emission_date';

    setTimeout(() => {
      this.filterPanelOpenState = false;
      // or: this.expansionPanel.close();
    }, 100);

    filterParams.is_draft = false; // ensures only non-drafts are fetched
    filterParams.is_deleted = false; // hide deleted invoices
    filterParams.is_preventive = false; // hide prevenitve invoices
    filterParams.is_saved_for_preview = false;
    // filterParams.status__not = 'SCARTATA';
    // filterParams.document_type = 'TD01'; // only invoices
    filterParams.emission_date__year = this.selectedYear;
    // ordering
    filterParams.ordering = '-progressive_number';

    // Using getRecursivePage to load all invoices across all pages
    this.invoicesSub?.unsubscribe();
    this.invoicesSub = this.invoiceService
      .getAllInvoices<InvoiceInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<InvoiceInterface>) => {
          if (response.completed) {
            // response.results = response.results.sort((a, b) => {
            //   return b.progressive_number - a.progressive_number;
            // });

            // All data has been loaded
            this.dataSource.data = response.results;
            this.dataSource.paginator = this.paginator;

            // Apply current filter
            this.applyFilter(this.selectedFilter);
            this.filteredInvoices = [...response.results]; // Initialize mobile view data

            // Calculate statistics
            this.totalInvoices = response.count; // Use count from response
            this.paidInvoices = response.results.filter(
              (invoice) => invoice.is_paid,
            ).length;

            this.calculateTotalAmountThisYear(response.results);

            console.log('All invoices loaded', response.results.length);

            this.isLoading = false;

            this.cdr.detectChanges();
          } else {
            // Optional: Show loading progress if you want
            console.log(`Loaded ${response.results.length} invoices so far...`);
          }
        },
        error: (err: any) => {
          console.error('Error loading invoices:', err);
          this.isLoading = false;
          this.showErrorMessage('Errore nel caricamento.');
          this.cdr.detectChanges();
        },
      });
  }

  private calculateTotalAmountThisYear(invoices: InvoiceInterface[]): void {
    // Initialize totals
    let totalAmountThisYear = 0;
    let totalAmountCreditThisYear = 0;

    invoices.forEach((invoice) => {
      // Check if invoice is from current year
      if (!invoice.emission_date) return;

      // Check if invoice is SCARTATA
      if (invoice.status === 'SCARTATA') return;

      const invoiceYear = new Date(invoice.emission_date).getFullYear();
      if (invoiceYear !== this.selectedYear) return;

      let invoiceAmount: number;

      // Calculate amount for this invoice if organization has INPS
      if (this.organization_data?.favorite_pension_fund === 'TC22') {
        invoiceAmount = Number(invoice.amount) || 0; // Number(invoice.gross_amount - invoice.discount_amount) || 0;
      } else {
        invoiceAmount =
          Number(invoice.amount - invoice.revenge - invoice.pension_fund) || 0;
      }

      // Add to credit total if type is 'TDO4'
      if (invoice.document_type === 'TD04') {
        totalAmountCreditThisYear += invoiceAmount;
      } else {
        // Add to general total
        totalAmountThisYear += invoiceAmount; // + Number(invoice.revenge);
      }
    });

    // Set the properties
    this.totalAmountThisYear = totalAmountThisYear;
    this.totalAmountCreditThisYear = totalAmountCreditThisYear;
  }

  // function to load companies from interface
  private loadCompanies() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // Niente isLoading qui: lo spinner riguarda solo le fatture. I clienti
    // arrivano di solito prima, e azzerarlo faceva comparire lo stato vuoto
    // mentre le fatture stavano ancora caricando.

    // Prepare filter params
    const filterParams: any = {};
    filterParams.is_deleted = false; // hide deleted invoices

    // if (this.sort && this.sort.active) {
    //   const direction = this.sort.direction === 'desc' ? '-' : '';
    //   filterParams.ordering = `${direction}${this.sort.active}`;
    // }

    this.companyService
      .getAllCompanies<CompanyInterface>(organization_id, filterParams)
      .subscribe({
        next: (companies: RecursiveInterface<CompanyInterface>) => {
          this.companySource.data = companies.results;
          // Extract company names from the response
          this.companyNames = companies.results.map(
            (company) => company.company_name,
          );
          console.log('loaded companies');

          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading companies:', err);
          this.showErrorMessage('Errore nel caricamento clienti.');
          this.cdr.detectChanges();
        },
      });
  }

  resetFilters() {
    this.filters = {
      amount_gt: null,
      amount_lt: null,
      emission_date_after: null,
      emission_date_before: null,
      payment_date_after: null,
      payment_date_before: null,
      status: null,
      company_name_icontains: null,
    };
    this.loadInvoices();
  }

  addNewElement(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(
      !this.newInvoice.organization_id || !this.newInvoice.company?.id,
    );
    console.log(this.newInvoice);
    this.invoiceService
      .createInvoice(organization_id, this.newInvoice)
      .subscribe({
        next: (createdInvoice: InvoiceInterface) => {
          this.dataSource.data = [...this.dataSource.data, createdInvoice];
          this.showSuccessMessage(
            `${createdInvoice.invoice_name} (amount ${createdInvoice.amount}) added successfully!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating invoice:', err);
          this.showErrorMessage('Errore durante la creazione.');
        },
      });
  }

  addNewCompany(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(!this.newCompany.organization_id || !this.newCompany.id);
    console.log(this.newCompany);
    this.companyService
      .createCompany(organization_id, this.newCompany)
      .subscribe({
        next: (createdCompany: CompanyInterface) => {
          this.companySource.data = [
            ...this.companySource.data,
            createdCompany,
          ];
          this.showSuccessMessage(
            `${createdCompany.company_name} (ID ${createdCompany.id}) added successfully!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating company:', err);
          this.showErrorMessage('Errore durante la creazione.');
        },
      });
  }

  // used in the autocomplete?
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.companyNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  onCompanyNameSelected(companyName: string) {
    const selectedCompany = this.companySource.data.find(
      // companySource?
      (company: { company_name: string }) =>
        company.company_name === companyName,
    );

    if (selectedCompany) {
      this.newInvoice.company_id = selectedCompany.id;
      console.log('Selected company ID:', selectedCompany.id);
    }
  }

  navigateToNewInvoice() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/new_invoice`]);
  }

  openQuickInvoice(): void {
    if (!this.organization_data) return;

    const ref = this.bottomSheet.open(QuickInvoiceBottomSheetComponent, {
      data: {
        organizationId: Number(
          this.route.snapshot.paramMap.get('organizationId'),
        ),
        organization: this.organization_data,
      },
      panelClass: 'quick-invoice-bottom-sheet',
    });

    ref.afterDismissed().subscribe((result) => {
      if (result?.reload) {
        this.loadInvoices();
      }
    });
  }

  navigateToUploadXML() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/upload_xml`]);
  }

  // Duplica una fattura aprendo "Nuova fattura" precompilata, come da
  // invoice-detail.component.ts (stesso servizio-ponte QuickInvoiceTransferService):
  // qui però le righe prodotto/servizio non sono ancora caricate (la tabella
  // mostra solo l'intestazione fattura), quindi vanno recuperate prima di
  // costruire il draft.
  duplicateInvoice(invoice: InvoiceInterface): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.productServiceApi
      .getAllProductsServices<ProductServiceInterface>(
        invoice.id,
        organization_id,
      )
      .subscribe({
        next: (response: RecursiveInterface<ProductServiceInterface>) => {
          if (!response.completed) {
            return;
          }

          const revenueStampOption: 'none' | 'customer' | 'me' =
            invoice.revenue_stamp > 0
              ? invoice.revenue_stamp_for_company
                ? 'customer'
                : 'me'
              : 'none';

          this.quickInvoiceTransferService.setInvoiceDuplicateDraft({
            invoice,
            productServices: response.results,
            revenueStampOption,
          });

          this.router.navigate([`/${organization_id}/new_invoice`]).then(() => {
            this.showSuccessMessage('Dati trasferiti nella nuova fattura.');
          });
        },
        error: (err: any) => {
          console.error('Error loading product services for duplication:', err);
          this.showErrorMessage('Impossibile duplicare la fattura');
        },
      });
  }

  onRowClick(invoice: InvoiceInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/invoice`, invoice.id]);
  }

  openCustomerPage(invoice: InvoiceInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/company`, invoice.company.id]);
  }

  togglePaidStatus(invoice: InvoiceInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.invoiceService
      .updateInvoiceDetails(organization_id, invoice.id, {
        is_paid: invoice.is_paid,
      })
      .subscribe({
        next: (updatedInvoice: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === invoice.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedInvoice;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalInvoices = this.dataSource.data.length;
            this.paidInvoices = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          this.showSuccessMessage(
            `La fattura (di ${invoice.amount} ${invoice.currency}) è stata aggiornata!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          invoice.is_paid = !invoice.is_paid;
          this.showErrorMessage('Errore. Riprova.');
        },
      });
  }

  // soft delete
  async deleteInvoice(invoice: InvoiceInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '90vw',
      maxWidth: '400px',
      /* Niente altezza fissa: con la barra azioni panna a filo bordo e' il
         contenuto a dettare l'altezza. Lo stile della superficie e' in
         styles.scss (.izy-confirm-dialog-panel): il dialog vive nell'overlay
         CDK, fuori dai componenti. */
      maxHeight: '90vh',
      panelClass: 'izy-confirm-dialog-panel',
      data: {
        invoiceName: invoice.invoice_name,
        /* Veste d'allarme: la fattura non torna indietro. Il dialog si mette
           da se' la panelClass .izy-danger-dialog-panel. */
        danger: true,
        title: 'Elimina fattura',
        message:
          'La fattura non è ancora stata trasmessa, quindi può essere ancora eliminata. Sicuro di voler eliminare la fattura?', // Custom message
        checkboxLabel: 'Confermo di voler eliminare la fattura e accetto', // Custom checkbox label
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result) {
      // User confirmed deletion - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Simulate 2-second delay + actual API call
      try {
        // Combine fake delay with actual API call
        await Promise.all([
          new Promise((resolve) => setTimeout(resolve, 2000)), // 2-second delay
          this.invoiceService
            .updateInvoiceDetails(organization_id, invoice.id, {
              is_deleted: true,
            })
            .toPromise(),
        ]);

        // Close loading dialog
        loadingDialogRef.close();

        // Remove from local data
        this.dataSource.data = this.dataSource.data.filter(
          (i) => i.id !== invoice.id,
        );
        this.filteredInvoices = this.filteredInvoices.filter(
          (i) => i.id !== invoice.id,
        );

        // Update statistics
        this.totalInvoices = this.dataSource.data.length;
        this.paidInvoices = this.dataSource.data.filter(
          (i) => i.is_paid,
        ).length;

        this.showSuccessMessage(
          `Fattura ${invoice.invoice_name} eliminata con successo!`,
        );
      } catch (err: any) {
        // Close loading dialog on error
        loadingDialogRef.close();

        console.error('Error deleting invoice:', err);
        this.showErrorMessage('Impossibile eliminare la fattura');
      }
    }
  }

  applyFilter(filterValue: string) {
    this.selectedFilter = filterValue;

    // Filter logic for both table and cards
    if (filterValue === 'all') {
      this.dataSource.filter = '';
      this.filteredInvoices = this.dataSource.data;
    } else {
      this.dataSource.filterPredicate = (
        data: InvoiceInterface,
        filter: string,
      ) => {
        if (filter === 'paid') return data.is_paid;
        if (filter === 'unpaid') return !data.is_paid;
        return true;
      };
      this.dataSource.filter = filterValue;
      this.filteredInvoices = this.dataSource.data.filter((invoice) => {
        if (filterValue === 'paid') return invoice.is_paid;
        if (filterValue === 'unpaid') return !invoice.is_paid;
        return true;
      });
    }

    // Update statistics based on filtered data
    const filteredData =
      this.filterValue === 'all' ? this.dataSource.data : this.filteredInvoices;
    this.totalInvoices = filteredData.length;
    this.paidInvoices = filteredData.filter(
      (invoice: { is_paid: any }) => invoice.is_paid,
    ).length;
  }

  downloadPdf(invoiceId: number): void {
    try {
      this.invoiceService.downloadInvoicePdf(invoiceId);
      this.showSuccessMessage(
        `La fattura è stata scaricata sul dispositivo con successo!`,
      );
    } catch (error) {
      this.showErrorMessage('Errore download PDF.');
    }
  }

  downloadXml(invoiceId: number): void {
    try {
      this.invoiceService.downloadInvoiceXml(invoiceId);
      this.showSuccessMessage(
        `La fattura XML è stata scaricata sul dispositivo con successo!`,
      );
    } catch (error) {
      this.showErrorMessage('Errore download XML.');
    }
  }

  async sendInvoiceEmail(
    invoiceId: number,
    Invoice: InvoiceInterface,
  ): Promise<void> {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmEmailSendDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '400px',
      data: {
        email_address: Invoice.company.email_address,
        company_id: Invoice.company.id,
        organization_id: organization_id,
      },
    });
    const result = await dialogRef.afterClosed().toPromise();

    if (!result) {
      // User cancelled the dialog
      return;
    }

    const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '300px',
      disableClose: true,
    });

    try {
      await this.invoiceService.sendEmailWithPDF(
        organization_id,
        invoiceId,
        Invoice,
      );
      loadingDialogRef.close();
      this.showSuccessMessage(
        `La fattura è stata inviata al cliente con successo!`,
      );
    } catch (error) {
      loadingDialogRef.close();
      this.showErrorMessage('Errore invio email con PDF.');
    }
  }

  openStatusInfoDialog() {
    const dialogRef = this.dialog.open(StatusInfoDialogComponent, {
      width: '90vw',
      maxWidth: '600px', // Slightly wider to accommodate the link
      /* Niente height fissa: la detta il contenuto fino al tetto di maxHeight,
         oltre il quale scorre. Con un'altezza imposta la fascia delle azioni
         resterebbe a mezz'aria sui contenuti piu' corti. */
      maxHeight: '700px',
      /* Stessa apertura del dettaglio fattura: e' lo stesso dialog, quindi
         deve avere la stessa veste da qualunque punto lo si apra. Lo stile e'
         in styles.scss (.izy-guide-dialog-panel), perche' il dialog vive
         nell'overlay CDK, fuori dai componenti. */
      panelClass: 'izy-guide-dialog-panel',
    });
  }

  handleInfoClick(event: MouseEvent) {
    event.stopPropagation(); // Previene la propagazione
    this.openStatusInfoDialog(); // Apre la dialog
  }

  handleAmountInfoClick(event: Event): void {
    // These two lines prevent the click from bubbling up and triggering anything else
    event.preventDefault();
    event.stopPropagation();

    // Open the simple info dialog
    this.dialog.open(this.amountInfoDialog, {
      width: '90%',
      maxWidth: '450px',
      autoFocus: false, // Prevents the button from being aggressively highlighted on open
    });
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newInvoice = {
      invoice_name: '',
      amount: 0,
      organization_id: 1,
      // company: this.companies[0], // {company_name:'default', id:1}
      company_id: 1,
    }),
      console.log('reset'));
  }

  formatTableAmount(amount: number, currency: string = 'EUR'): string {
    const formatted = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return formatted;
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.toast.success(message);
  }

  private showErrorMessage(message: string): void {
    this.toast.error(message);
  }
}
